// frontend/src/api/tags.js
import client from "./client";

/**
 * Tag API — wrappers around the /api/tags endpoints (P14-G3).
 */

/**
 * List the org's tags (name-sorted).
 * @returns {Promise<Array<{id, name, color_hex, created_at}>>}
 */
export async function listTags() {
  const response = await client.get("/api/tags");
  return response.data;
}

/**
 * Create a tag (admin+).
 * @param {{ name: string, color_hex?: string }} payload
 * @returns {Promise<object>}
 */
export async function createTag(payload) {
  const response = await client.post("/api/tags", payload);
  return response.data;
}

/**
 * Delete a tag, detaching it from all codes (admin+).
 * @param {string} tagId
 * @returns {Promise<void>}
 */
export async function deleteTag(tagId) {
  await client.delete(`/api/tags/${tagId}`);
}

/**
 * List the tags currently attached to a code.
 * @param {number} codeId
 * @returns {Promise<Array<object>>}
 */
export async function getCodeTags(codeId) {
  const response = await client.get(`/api/codes/${codeId}/tags`);
  return response.data;
}

/**
 * Attach a tag to a code (member+). Returns the code's updated tag list.
 * @param {number} codeId
 * @param {string} tagId
 * @returns {Promise<Array<object>>}
 */
export async function addTagToCode(codeId, tagId) {
  const response = await client.post(`/api/codes/${codeId}/tags`, {
    tag_id: tagId,
  });
  return response.data;
}

/**
 * Detach a tag from a code (member+).
 * @param {number} codeId
 * @param {string} tagId
 * @returns {Promise<void>}
 */
export async function removeTagFromCode(codeId, tagId) {
  await client.delete(`/api/codes/${codeId}/tags/${tagId}`);
}
